import React, { useState } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import MuiDialogActions from '@material-ui/core/DialogActions'
import MuiDialogContent from '@material-ui/core/DialogContent'
import TextField from '@material-ui/core/TextField'
import MuiButton from '@material-ui/core/Button'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'
import { ThemeProvider as MuiThemeProvider } from '@material-ui/core/styles'
import createMuiTheme from '@material-ui/core/styles/createMuiTheme'
import Slide from '@material-ui/core/Slide'
import { dismissPopover } from 'services/OverlayService'

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500]
  }
})

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2)
  }
}))(MuiDialogContent)

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  }
}))(MuiDialogActions)

const DialogTitle = withStyles(styles)(({ children, classes, onClose }) => (
  <MuiDialogTitle className={classes.root}>
    {children}
    <IconButton aria-label='close' className={classes.closeButton} onClick={onClose}>
      <CloseIcon />
    </IconButton>
  </MuiDialogTitle>
))

const theme = createMuiTheme({ palette: { primary: { main: '#004b7a' } } })

const LinkEditor = ({ url, cancel, callback, pageToggleOverlay }) => {
  const [open, setOpen] = useState(true)
  const [value, setValue] = useState(url || '')
  const submitValue = (value) => {
    pageToggleOverlay()
    callback(value)
  }
  const handleSubmit = (e) => {
    e.preventDefault()
    setOpen(false)
    submitValue(value)
  }
  const handleClose = () => {
    setOpen(false)
    cancel() || pageToggleOverlay(null)
  }

  return (
    <MuiThemeProvider theme={theme}>
      <div
        onClick={(e) => {
          dismissPopover(e.target)
          e.stopPropagation()
        }}
      >
        <Dialog
          fullWidth
          hideBackdrop
          keepMounted
          open={open}
          onClose={handleClose}
          TransitionComponent={Slide}
        >
          <DialogTitle onClose={handleClose}>
            <div className='f3'>Edit Link</div>
          </DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              placeholder={`${location.protocol}//`}
              margin='dense'
              type='url'
              fullWidth
              variant='outlined'
              value={value}
              onChange={(e) => {
                setValue(e.target.value)
              }}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color='primary' variant='contained'>
              Cancel
            </Button>
            <Button onClick={handleSubmit} color='primary' variant='contained'>
              {!url ? 'Add link' : 'Update link'}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </MuiThemeProvider>
  )
}

const Button = withStyles({ root: { textTransform: 'none' } })(MuiButton)

export default LinkEditor
